import React, { useEffect, useRef, useState } from "react";
import { isMobile } from "react-device-detect";
import { apis } from "../../config/APIs";
import usePayAxios from "../../config/useAxios";

const OTPComponent = (props) => {
  const isVerifyOtp = props.isVerifyOtp;
  const { onCall, data, reset } = usePayAxios({
    api: apis.resendOTP,
    method: "post",
  });
  const [otpIndex, setOtpIndex] = useState(0);
  // const [isEdit, setIsEdit] = useState(false);
  const numKeyCodes = Array.from({ length: 10 }, (_, i) => i + 48);
  const numPadKeyCodes = Array.from({ length: 10 }, (_, i) => i + 96);

  const otpRefs = useRef([]);

  const expirySecondsFromProps = Number.isFinite(
    Number(props?.otpExpiryInMinutes)
  )
    ? Number(props.otpExpiryInMinutes) * 60
    : Number.isFinite(Number(props?.otpExpiryInSeconds))
      ? Number(props.otpExpiryInSeconds)
      : 120;

  const [state, setState] = useState({
    timeLeft: expirySecondsFromProps,
    resendMessage: false,
  });

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      timeLeft: expirySecondsFromProps,
      resendMessage: false,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expirySecondsFromProps]);

  useEffect(() => {
    if (!state.timeLeft) return;
    const intervalId = setInterval(() => {
      setState({ ...state, timeLeft: state.timeLeft - 1 });
    }, 1000);
    return () => clearInterval(intervalId);
  }, [state.timeLeft]);

  useEffect(() => {
    otpRefs.current[0].focus();
    otpRefs.current[0].onkeyup = (e) => {
      if (e.keyCode === 39) {
        otpRefs.current[1].focus();
        setOtpIndex(1);
      }
    };
    if (props.value) {
      setOtpIndex(props.value.length - 1);
      props.value.split("").forEach((val, idx) => {
        otpRefs.current[idx].value = val;
      });
      otpRefs.current[props.value.length - 1].focus();
    }
  }, []);

  useEffect(() => {
    if (props.value === "" || props.value === null || props.value === undefined) {
      setOtpIndex(0);
      otpRefs.current.forEach((val, idx) => {
        if (otpRefs.current[idx]) {
          otpRefs.current[idx].value = "";
        }
      });
      if (otpRefs.current[0]) {
        otpRefs.current[0].focus();
      }
    }
  }, [props.value]);

  useEffect(() => {
    let idx = otpIndex,
      len = otpRefs.current.length;
    let keyCount = 0;
    otpRefs.current[idx].onkeyup = (e) => {
      if (e.keyCode === 37 && idx >= 1) {
        otpRefs.current[idx - 1].select();
        setOtpIndex(idx - 1);
      }

      if (e.keyCode === 39 && idx >= 0 && idx + 1 < len) {
        otpRefs.current[idx + 1].select();
        setOtpIndex(idx + 1);
      }

      if (e.keyCode === 8 || e.keyCode === 46) {
        if (idx - 1 >= 0) {
          otpRefs.current[idx].value = "";
          if (keyCount === 1) {
            otpRefs.current[idx - 1].select();
            setOtpIndex(idx - 1);
            keyCount = 0;
          }
          keyCount++;
        }
        if (idx === 0) {
          otpRefs.current[idx].value = "";
        }
      } else {
        if (
          idx + 1 < len &&
          (numKeyCodes.includes(e.keyCode) ||
            numPadKeyCodes.includes(e.keyCode ? e.keyCode : e.which))
        ) {
          otpRefs.current[idx].value = e.key;
          otpRefs.current[idx + 1].select();
          setOtpIndex(idx + 1);
        } else {
          if (
            numKeyCodes.includes(e.keyCode) ||
            numPadKeyCodes.includes(e.keyCode ? e.keyCode : e.which)
          ) {
            otpRefs.current[idx].value = e.key;
            // props.onChange(
            //   otpRefs.current.map((item) => item?.value).join("")
            // );
          }
        }
        keyCount = 0;
      }
      props.onChange(otpRefs.current.map((item) => item?.value).join(""));
    };
  }, [otpIndex]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <>
      <p
        className="enterOTP alignCenter mt-2 text-center mb-1"
        style={{ color: isVerifyOtp ? "#fff" : "#000" }}
      >
        {props.label ? props.label : "Enter OTP"}
      </p>
      {/* <Field name="otp" autoComplete="off" maxLength={6} /> */}
      <div className="otpInputBlock">
        <div className="otpInputField">
          <input
            disabled={props.loading}
            name="otp"
            autoComplete="off"
            maxLength={1}
            type={isMobile ? "number" : "text"}
            value={otpRefs.current[0]?.value}
            ref={(ref) => (otpRefs.current[0] = ref)}
          />
        </div>
        <div className="otpInputField">
          <input
            disabled={props.loading}
            name="otp"
            autoComplete="off"
            maxLength={1}
            type={isMobile ? "number" : "text"}
            value={otpRefs.current[1]?.value}
            ref={(ref) => (otpRefs.current[1] = ref)}
          />
        </div>
        <div className="otpInputField">
          <input
            disabled={props.loading}
            name="otp"
            autoComplete="off"
            maxLength={1}
            type={isMobile ? "number" : "text"}
            value={otpRefs.current[2]?.value}
            ref={(ref) => (otpRefs.current[2] = ref)}
          />
        </div>
        <div className="otpInputField">
          <input
            disabled={props.loading}
            name="otp"
            autoComplete="off"
            maxLength={1}
            type={isMobile ? "number" : "text"}
            value={otpRefs.current[3]?.value}
            ref={(ref) => (otpRefs.current[3] = ref)}
          />
        </div>
        {!props.isFourDigit && (
          <>
            <div className="otpInputField">
              <input
                disabled={props.loading}
                name="otp"
                autoComplete="off"
                maxLength={1}
                type={isMobile ? "number" : "text"}
                value={otpRefs.current[4]?.value}
                ref={(ref) => (otpRefs.current[4] = ref)}
              />
            </div>
            <div className="otpInputField">
              <input
                disabled={props.loading}
                name="otp"
                autoComplete="off"
                maxLength={1}
                type={isMobile ? "number" : "text"}
                value={otpRefs.current[5]?.value}
                ref={(ref) => (otpRefs.current[5] = ref)}
              />
            </div>
          </>
        )}
      </div>
      <div className="timeLeft">
        {state.timeLeft > 0 && (
          <div
            className="alignCenter"
            style={{ color: isVerifyOtp ? "#fff" : "#000" }}
          >
            OTP expires in{" "}
            {expirySecondsFromProps > 120
              ? formatTime(state.timeLeft)
              : `${state.timeLeft} seconds`}
          </div>
        )}

        {state.timeLeft === 0 &&
          !data?.message &&
          (props?.otpData?.otp_token || props?.resendOtp) && (
            <h5
              className="otpMsg alignCenter mt-2 text-center mb-1"
              // style={{ color: "var(--text-primary)" }}
              style={{ color: isVerifyOtp ? "#fff" : "#000" }}
              onClick={() => {
                if (props?.resendOtp) {
                  props?.resendOtp?.();
                } else {
                  onCall({
                    data: {
                      // user_id: props?.otpData?.user_id,
                      otp_token: props?.otpData?.otp_token,
                      source: props.source,
                      // email_id: props?.otpData?.email,
                      // mobile_number: props?.otpData?.mobile,
                    },
                  })
                    .then((res) => {
                      if (res?.response) {
                        props.setUserData((b) => ({
                          ...b,
                          otp_token: res?.response?.data?.otp_token,
                        }));
                      }
                      let timeout = setTimeout(() => {
                        reset();
                        clearTimeout(timeout);
                      }, 6000);
                      props.onChange("");
                      otpRefs.current?.forEach((ele) => {
                        ele.value = "";
                      });
                    })
                    .catch(() => {
                      let timeout = setTimeout(() => {
                        reset();
                        clearTimeout(timeout);
                      }, 6000);
                    });
                }
                setState({
                  ...state,
                  timeLeft: expirySecondsFromProps,
                  resendMessage: true,
                });
              }}
            >
              Didn't receive OTP?
              <span className="Cursor resendOtp  emp-text">Resend OTP</span>
            </h5>
          )}
        {state.resendMessage && data?.message && (
          <h4 className="text-center" style={{ color: "var(--text-primary)" }}>
            OTP sent successfully
          </h4>
        )}

        {state.timeLeft === 0 && !data?.message && (
          <h4
            className="alignCenter text-center"
            style={{ color: "var(--text-primary)" }}
          >
            OTP Expired
          </h4>
        )}
      </div>
    </>
  );
};

export default OTPComponent;
